// extracted by mini-css-extract-plugin
module.exports = {"wheel":"colorWheel-module--wheel--19_ND","colorLeaf":"colorWheel-module--colorLeaf--2Ao_f","intro":"colorWheel-module--intro--23CD-"};